import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkIsEmpty, getSessionData } from "utils/common";

const initialState = {
  accountTypeOptionList: [],
  segmentsList: [],
  symbolList: [],
  scriptList: [],
  messageOptions: "success added",
  message: "",
  showMessage: false,
  varient: "success",
  openDeleteConfirmDialog: false,
  agentORSubBrokerList: [],
  expiryDatesBySymbolList: [],
  accountOptionList: [],
  partnerList: [],
  cashbookList: [],
  systemUserList: [],
  isNavbarHidden: false,
  editDataObjectCommon: {},
  commonAllUsers: [],
  focusState: false,
  rightsSessionList: [],
  notificationList: [],
  pushnotificationList: [],
  availableBalance: {},
  amountRangeList:[],
  whatappRecords:[],
  paymentGetway:[],
  bankDetails:[],
  isAddFund:false,
  addFundLoading:false,
  isBankUpdated:false,
  userBankLoading:false,
  iswithdrawFund:false,
  withdrawFundLoading:false,
  segmentListLoading: false,
  accountCommonListLoading: false,
  symbolListLoading: false,
  privacyPolicyData: [],
  symbolListWithExpiry: [],
  isAcceptedRules: false,
  isAcceptedRulesLoader: false,
  payInOutListLoading:false,
  payInList:[],
  payOutList:[],
  totalPayInRecord:0,
  totalPayOutRecord:0,
  cashbookByRoleNameList:[],
};

export const getSegmentKeyWorkByValue = (selectObject) => {
  if (selectObject.value === 1) {
    return "fonse";
  } else if (selectObject.value === 2) {
    return "mcx";
  } else if (selectObject.value === 3) {
    return "fonse";
  } else if (selectObject.value === 4) {
    return "nsecd";
  }
};

export const isAllowShow = createAsyncThunk(
  "/isAllowShow/bool",
  (routeName, { dispatch, getState }) => {
    return new Promise((resolve, reject) => {
      let { rightsSessionList } = getState().common;
      let { roles } = getSessionData();
      if (roles[0] === "Super Admin") {
        resolve(true);
      } else {
        let arr =
          rightsSessionList &&
          rightsSessionList.filter((a) => a.routeName === routeName);
        if (arr.length > 0) {
          resolve(arr[0].isViewAllow);
        } else {
          resolve(false);
        }
      }
    });
  }
);

export const getSegmentOptionList = createAsyncThunk(
  "/segment/get",
  (data, { getState }) => {
    return new Promise((resolve, reject) => {
      const { segmentsList = [] } = getState().common;
      if (segmentsList?.length > 0) {
        resolve(segmentsList);
        return;
      }
      axios
        .get("master/segment/get-segments")
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            const newDataArray =
              data &&
              data.map((item, i) => {
                return { label: item.name, value: item.id,digitAfterPoint:item.digitAfterPoint};
              });
            resolve(newDataArray);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getSegmentOptionListByUser = createAsyncThunk(
  "/segment-by-user/get",
  (userId, { getState }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`master/segment/get-segments-by-user-id/${userId}`)
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            const newDataArray =
              data &&
              data.map((item, i) => {
                 return { label: item.name, value: item.id,digitAfterPoint:item.digitAfterPoint};
              });
            resolve(newDataArray);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getScriptList = createAsyncThunk(
  "/script/get",
  ({ id }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `settings/symbol-expiry/get-symbol-expiry-symbols-by-segment/${id}`
        )
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getPrivacyPolicyData = createAsyncThunk(
  "get-privacy-policy",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get("common/get-privacy-policy-data")
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

let ajaxSymbolListRequest = null;
export const getSymbolList = createAsyncThunk(
  "/symbol/get",
  ({ id, optType }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      if (ajaxSymbolListRequest) ajaxSymbolListRequest.cancel("CANCEL");
      ajaxSymbolListRequest = axios.CancelToken.source();

      axios
        .get(
          `market-watch/get-symbols-by-segment/${id}${optType ? `?optType=${optType}` : ""
          }
        `,
          { cancelToken: ajaxSymbolListRequest.token }
        )
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getSymbolListWithExpiry = createAsyncThunk(
  "/symbol-with-exp/get",
  (segmentId, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`script/bhav-copy/Get-Script-Data-By-SegmentId/${segmentId}`)
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const isRulesAccepted = createAsyncThunk(
  "/rules-accepted",
  (props) => {
    return new Promise((resolve, reject) => {
      axios
        .get('common/is-rules-accepted')
        .then(({ data }) => {
          if (data?.status === 200) {
            resolve(true);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getSymbolListForNse = createAsyncThunk(
  "/symbol/get-opt",
  ({ segmentId, IsQtySet }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      if (ajaxSymbolListRequest) ajaxSymbolListRequest.cancel("CANCEL");
      ajaxSymbolListRequest = axios.CancelToken.source();
      axios
        .get(`market-watch/get-MW-symbols-for-nse/${segmentId}${IsQtySet ? `?IsQtySet=${IsQtySet}` : ""
          }`)
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getAgentSubBroker = createAsyncThunk("/agentSubBroker", () => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();

    axios
      .get(`common/get-sub-brokers/${userId}`)
      .then(({ data }) => {
        let { status, data: dataArray } = data;
        if (status === 200 && dataArray && dataArray.length > 0) {
          resolve(dataArray);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});

export const getTokenScriptWiseLiveRateList = createAsyncThunk(
  "/script/get",
  ({ id }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `settings/symbol-expiry/get-symbol-expiry-symbols-by-segment/${id}`
        )
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getAccountCommonList = createAsyncThunk(
  "/account/common",
  ({ userId, roleName }) => {
    return new Promise((resolve, reject) => {
      userId
        ? axios
          .get(
            `common/get-account-names-by-authorityid-and-rolename/${userId}/${roleName}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              let { data: dataArray } = data;
              if (dataArray && dataArray.length > 0) {
                resolve({ dataArray, roleName });
              } else {
                reject(data);
              }
            } else {
              reject(data);
            }
          })
          .catch((error) => {
            reject(error);
          })
        : axios
          .get(`common/get-account-names-by-rolename/${roleName}`)
          .then(({ data }) => {
            if (data.status === 200) {
              let { data: dataArray } = data;
              resolve({ dataArray, roleName });
            } else {
              reject(data);
            }
          })
          .catch((error) => {
            reject(error);
          });
    });
  }
);

export const getAccountTypeOption = createAsyncThunk("/accountType", () => {
  return new Promise((resolve, reject) => {
    axios
      .get("common/get-account-types")
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          const newDataArray =
            data &&
            data.map((item, i) => {
              return { label: item.name, value: item.id };
            });
          resolve(newDataArray);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const getCashbookByRoleName = createAsyncThunk("/cashbookbyrolename", () => {
  return new Promise((resolve, reject) => {
    axios
      .get("common/get-account-names-and-cashbook-by-rolename/cashbook")
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const getNotificationList = createAsyncThunk("/getNotification", () => {
  return new Promise((resolve, reject) => {
    axios
      .get("common/get-today-notification-list")
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          if (data.length > 0) {
            data = data.reverse();
          }
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const markNotification = createAsyncThunk("/markNotification", () => {
  return new Promise((resolve, reject) => {
    axios
      .get("common/notifications/mark-as-all-read")
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const clearNotification = createAsyncThunk("/clearNotification", () => {
  return new Promise((resolve, reject) => {
    axios
      .get("common/notifications/clear-all-readed-notifications")
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const getPushNotificationList = createAsyncThunk("/pushgetNotification", () => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();
    axios
      .get(`common/notifications/get-push-notifications-details/${userId}/1/50`)
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          if (data.records.length > 0) {
            data = data.records.reverse();
          }
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const getAvailableBalance = createAsyncThunk("/availablebalance", () => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();
    axios
      .get(`reports/ledger-report/get-ledger-balance-for-user`)
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});

export const getRangeList = createAsyncThunk("/getRangeList", () => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();
    axios
      .get(`finance/bank-detail/get-bank-details-for-user/${userId}/1/10000`)
      .then((resData) => {
        if (resData.status === 200) {
          let { data } = resData.data;
          resolve(data);
        } else {
          reject(resData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const addFund =  createAsyncThunk(
  "addFund",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      let finalObject = data;
      finalObject.createdBy=userId;
      finalObject.id=0;
      finalObject.userId=userId;
      finalObject.transactionId=data.transactionId;
      finalObject.amount=data.amount;
      finalObject.remark=data.remark;
      finalObject.payInImage=data.transactionFile;
      finalObject.status=1;
      axios
        .post("finance/Pay-InOut/save-pay-in-detail", finalObject)
        .then(({ data: dataRep }) => {
          if (dataRep.status == 200) {
            dispatch(
              showMessage({ message: dataRep.message, varient: "success" })
            );
            resolve(data.data);
          } else {
            reject(dataRep);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const leoPayIn =  createAsyncThunk(
  "leoPayIn",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      let { amount }= data;
      axios
        .get(`PaymentGateway/online-pay-in?amount=${amount}`)
        .then(({ data: dataRep }) => {
          if (dataRep.status == 200) {
            dispatch(
              showMessage({ message: dataRep.message, varient: "success" })
            );
            if (dataRep.data?.redirectUrl) {
                const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                const width = isMobile ? window.innerWidth : 800;
                const height = isMobile ? window.innerHeight : 600;
                const left = isMobile ? 0 : (window.innerWidth - width) / 2;
                const top = isMobile ? 0 : (window.innerHeight - height) / 2;
                window.open(
                  dataRep.data.redirectUrl,
                  "LeoPayPayment",
                  `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
                );
            }
            resolve(data.data);
          } else {
            reject(dataRep);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const withdrawFund =  createAsyncThunk(
  "withdrawFund",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      let finalObject = {};
      finalObject.bankUPI=data.upiId
      finalObject.bankName=data.bankName
      finalObject.bankHolderName=data.beneficiaryName;
      finalObject.bankAccountNumber=data.accountNumber
      finalObject.bankIFSC=data.ifscCode
      finalObject.createdBy=userId;
      finalObject.id=0;
      finalObject.userId=userId;
      finalObject.status=1;
      finalObject.amount=data.amount
      axios
        .post("finance/Pay-InOut/save-pay-out-detail", finalObject)
        .then(({ data: dataRep }) => {
          if (dataRep.status == 200) {
            dispatch(
              showMessage({ message: dataRep.message, varient: "success" })
            );
            resolve(data.data);
          } else {
            reject(dataRep);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const getPayInOutList = createAsyncThunk(
  "payInOutList",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      let payOut=data.payOut;
      let page=data.page;
      axios
        .get(`finance/Pay-InOut/get-${payOut}-details/${userId}/${page}/10/0`)
        .then(({ data }) => {
          if (data.status == 200) {
            resolve({ data: data.data,type:payOut,page:page});
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getBankDetails = createAsyncThunk(
  "getBankDetails",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      axios
        .get(`finance/bank-detail/get-bank-details-for-users/${userId}/1/1000`)
        .then(({ data }) => {
          if (data.status === 200) {
            resolve(data.data);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const saveBankDetails = createAsyncThunk(
  "saveBankDetails",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId, roles } = getSessionData();
      let finalObject = {
            id: data.bankId?data.bankId:0,
            bankUPI: data.upiId,
            bankName: data.bankName,
            bankHolderName: data.beneficiaryName,
            bankAccountNumber: data.accountNumber,
            bankIFSC: data.ifscCode,
            bankUPIImage: "",
            createdBy: userId,
            endAmountRange: 0,
            isBankActive: true,
            startAmountRange: 0,
            bankAddress: "",
            deleted: false,
            userId: userId
      };
      axios
        .post("finance/bank-detail/save-bank-detail", finalObject)
        .then(({ data: dataRep }) => {
          if (dataRep.status == 200) {
            dispatch(
              showMessage({ message: dataRep.message, varient: "success" })
            );
            resolve(data.data);
          } else {
            reject(dataRep);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const deleteUserBank = createAsyncThunk(
  "deleteUserBank",
  (bankId, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `finance/bank-detail/delete-bank-detail/${bankId}`
        )
        .then(({ data }) => {
          if (data.status == 200) {
            dispatch(
              showMessage({ message: data.message, varient: "success" })
            );
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const getSymbolExpiryFromSymbol = createAsyncThunk(
  "/setting/symbol expiry/get",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { id } = data;
      axios
        .get(`settings/symbol-expiry/get-expiry-dates-by-symbol/${id}`)
        .then(({ data }) => {
          let { status, data: dataArray } = data;
          if (status === 200 && dataArray && dataArray.length > 0) {
            resolve(dataArray);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getEditDataObjectCommon = createAsyncThunk(
  "/edit/data-object/get",
  (url, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}`)
        .then((res) => {
          let { status, data } = res.data;
          if (status === 200 && !checkIsEmpty(data)) {
            resolve(data);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getRightsForSession = createAsyncThunk(
  "admin/getRightsForSession/list",
  (id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`settings/authorityRights/get-authorityRights-by-userid/${id}`)
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            sessionStorage.setItem(
              "TradeAuthoritySession",
              JSON.stringify(data)
            );
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    showMessage: (state, action) => {
      state.message = action.payload.message;
      state.varient = action.payload.varient;
      state.showMessage = true;
    },
    hideMessage: (state, action) => {
      state.showMessage = false;
    },
    setOpenDeleteConfirmDialog: (state, action) => {
      state.openDeleteConfirmDialog = action.payload;
    },
    setSymbolList: (state, action) => {
      state.symbolList = action.payload;
    },
    setAgentORSubBrokerList: (state, action) => {
      state.agentORSubBrokerList = action.payload;
    },
    setAccountOptionList: (state, action) => {
      state.accountOptionList = action.payload;
    },
    setIsNavbarHidden: (state, action) => {
      state.isNavbarHidden = action.payload;
    },
    setEditDataObjectCommon: (state, action) => {
      state.editDataObjectCommon = action.payload;
    },
    setFocusState: (state, action) => {
      state.focusState = action.payload;
    },
    setCommonAllUsers: (state, action) => {
      state.commonAllUsers = action.payload;
    },
    setSymbolListWithExpiry: (state, action) => {
      state.symbolListWithExpiry = action.payload;
    },
    setIsAcceptedRules: (state, action) => {
      state.isAcceptedRules = action.payload;
    },
    setIsBankUpdated: (state, action) => {
      state.isBankUpdated = action.payload;
    },
  },
  extraReducers: {
    [getAccountCommonList.pending]: (state, action) => {
      // state.accountOptionList = [];
      state.accountCommonListLoading = true;
    },
    [getAccountCommonList.rejected]: (state, action) => {
      state.accountOptionList = [];
      state.accountCommonListLoading = false;
    },
    [getAccountCommonList.fulfilled]: (state, action) => {
      state.accountCommonListLoading = false;
      if (action.payload.roleName === "User") {
        state.accountOptionList = action.payload.dataArray;
      } else if (
        action.payload.roleName === "Sub Broker" ||
        action.payload.roleName === "Broker"
      ) {
        state.agentORSubBrokerList = action.payload.dataArray;
      } else if (action.payload.roleName === "Partner") {
        state.partnerList = action.payload.dataArray;
      } else if (action.payload.roleName === "Cashbook") {
        state.cashbookList = action.payload.dataArray;
      } else if (action.payload.roleName === "System User") {
        state.systemUserList = action.payload.dataArray;
      }
      state.commonAllUsers = action.payload.dataArray;
    },
    //account type
    [getAccountTypeOption.pending]: (state, action) => {
      // state.accountTypeOptionList = [];
    },
    [getAccountTypeOption.rejected]: (state, action) => {
      state.accountTypeOptionList = [];
    },
    [getAccountTypeOption.fulfilled]: (state, action) => {
      state.accountTypeOptionList = action.payload;
    },
    [getCashbookByRoleName.pending]: (state, action) => {
      state.cashbookByRoleNameList = [];
    },
    [getCashbookByRoleName.rejected]: (state, action) => {
      state.cashbookByRoleNameList = [];
    },
    [getCashbookByRoleName.fulfilled]: (state, action) => {
      state.cashbookByRoleNameList = action.payload;
    },
    //segment list
    [getSegmentOptionList.pending]: (state, action) => {
      // state.segmentsList = [];
    },
    [getSegmentOptionList.rejected]: (state, action) => {
      // state.segmentsList = [];
    },
    [getSegmentOptionList.fulfilled]: (state, action) => {
      state.segmentsList = action.payload;
      state.segmentListLoading = false;
    },
    [getSegmentOptionListByUser.fulfilled]: (state, action) => {
      state.segmentsList = action.payload;
      state.segmentListLoading = false;
    },
    //script list
    [getScriptList.pending]: (state, action) => {
      state.scriptList = [];
    },
    [getScriptList.rejected]: (state, action) => {
      state.scriptList = [];
    },
    [getScriptList.fulfilled]: (state, action) => {
      state.scriptList = action.payload;
    },
    [isRulesAccepted.pending]: (state, action) => {
      state.isAcceptedRulesLoader = true
    },
    [isRulesAccepted.rejected]: (state, action) => {
      state.isAcceptedRules = false
      state.isAcceptedRulesLoader = false
    },
    [isRulesAccepted.fulfilled]: (state, action) => {
      state.isAcceptedRules = action?.payload || false
      state.isAcceptedRulesLoader = false
    },
    [getPrivacyPolicyData.pending]: (state, action) => {
      state.privacyPolicyData = [];
    },
    [getPrivacyPolicyData.rejected]: (state, action) => {
      state.privacyPolicyData = [];
    },
    [getPrivacyPolicyData.fulfilled]: (state, action) => {
      state.privacyPolicyData = action.payload;
    },

    [getSymbolList.pending]: (state, action) => {
      state.symbolList = [];
      state.symbolListLoading = true;
    },
    [getSymbolList.rejected]: (state, action) => {
      state.symbolList = [];
      state.symbolListLoading = false;
    },
    [getSymbolList.fulfilled]: (state, action) => {
      state.symbolList = action.payload;
      state.symbolListLoading = false;
    },
    [getSymbolListWithExpiry.pending]: (state, action) => {
      state.symbolListWithExpiry = [];
      state.symbolListLoading = true;
    },
    [getSymbolListWithExpiry.rejected]: (state, action) => {
      state.symbolListWithExpiry = [];
      state.symbolListLoading = false;
    },
    [getSymbolListWithExpiry.fulfilled]: (state, action) => {
      state.symbolListWithExpiry = action.payload;
      state.symbolListLoading = false;
    },
    [getSymbolListForNse.pending]: (state, action) => {
      state.symbolList = [];
      state.symbolListLoading = true;
    },
    [getSymbolListForNse.rejected]: (state, action) => {
      state.symbolList = [];
      state.symbolListLoading = false;
    },
    [getSymbolListForNse.fulfilled]: (state, action) => {
      state.symbolList = action.payload;
      state.symbolListLoading = false;
    },
    [getNotificationList.pending]: (state, action) => {
      state.notificationList = action.payload;
    },
    [getNotificationList.rejected]: (state, action) => {
      state.notificationList = action.payload;
    },
    [getNotificationList.fulfilled]: (state, action) => {
      state.notificationList = action.payload;
    },

    [getPushNotificationList.pending]: (state, action) => {
      state.pushnotificationList = [];
    },
    [getPushNotificationList.rejected]: (state, action) => {
      state.pushnotificationList = [];
    },
    [getPushNotificationList.fulfilled]: (state, action) => {
      if (Array.isArray(action.payload) && action.payload.length > 0) {
          state.pushnotificationList = action.payload;
      } else {
          state.pushnotificationList = [];
      }
    },

    [getAvailableBalance.pending]: (state, action) => {
      state.availableBalance = {};
    },
    [getAvailableBalance.rejected]: (state, action) => {
      state.availableBalance = {};
    },
    
    [getAvailableBalance.fulfilled]: (state, action) => {
     if (typeof action.payload.balance !== "undefined") {
          state.availableBalance = action.payload;
      } else {
          state.availableBalance = {};
      }
    },
    [getBankDetails.pending]: (state, action) => {
      state.bankDetails = [];
    },
    [getBankDetails.rejected]: (state, action) => {
      state.bankDetails = [];
    },
    
    [getBankDetails.fulfilled]: (state, action) => {
      if (Array.isArray(action.payload.records) && action.payload.records.length > 0) {
          state.bankDetails = action.payload.records;
      } else {
          state.bankDetails = [];
      }
    },
    [saveBankDetails.pending]: (state, action) => {
      state.userBankLoading=true;
      state.isBankUpdated = false;
    },
    [saveBankDetails.rejected]: (state, action) => {
      state.userBankLoading=false;
      state.isBankUpdated = false;
    },
    [saveBankDetails.fulfilled]: (state, action) => {
      state.userBankLoading=false;
      state.isBankUpdated = true;
    },
    [deleteUserBank.pending]: (state, action) => {
      state.userBankLoading=true;
      state.isBankUpdated = false;
    },
    [deleteUserBank.rejected]: (state, action) => {
      state.userBankLoading=false;
      state.isBankUpdated = false;
    },
    [deleteUserBank.fulfilled]: (state, action) => {
      state.userBankLoading=false;
      state.isBankUpdated = true;
    },
    [getRangeList.pending]: (state, action) => {
      state.amountRangeList = [];
      state.whatappRecords = [];
    },
    [getRangeList.rejected]: (state, action) => {
      state.amountRangeList = [];
      state.whatappRecords = [];
    },
    
    [getRangeList.fulfilled]: (state, action) => {
      if (Array.isArray(action.payload.records) && action.payload.records.length > 0) {
          state.amountRangeList = action.payload.records;
      } else {
          state.amountRangeList = [];
      }
      if (Array.isArray(action.payload.whatappRecord) && action.payload.whatappRecord.length > 0) {
          state.whatappRecords = action.payload.whatappRecord;
      } else {
          state.whatappRecords = [];
      }
      if (Array.isArray(action.payload.paymentGetway) && action.payload.paymentGetway.length > 0) {
          state.paymentGetway = action.payload.paymentGetway;
      } else {
          state.paymentGetway = [];
      }
    },

    [addFund.pending]: (state, action) => {
      state.addFundLoading=true;
      state.isAddFund = false;
    },
    [addFund.rejected]: (state, action) => {
      state.addFundLoading=false;
      state.isAddFund = false;
    },
    [addFund.fulfilled]: (state, action) => {
      state.addFundLoading=false;
      state.isAddFund = true;
    },
    [leoPayIn.pending]: (state, action) => {
      state.addFundLoading=true;
      state.isAddFund = false;
    },
    [leoPayIn.rejected]: (state, action) => {
      state.addFundLoading=false;
      state.isAddFund = false;
    },
    [leoPayIn.fulfilled]: (state, action) => {
      state.addFundLoading=false;
      state.isAddFund = true;
    },
    [withdrawFund.pending]: (state, action) => {
      state.withdrawFundLoading=true;
      state.iswithdrawFund = false;
    },
    [withdrawFund.rejected]: (state, action) => {
      state.withdrawFundLoading=false;
      state.iswithdrawFund = false;
    },
    [withdrawFund.fulfilled]: (state, action) => {
      state.withdrawFundLoading=false;
      state.iswithdrawFund = true;
    },
    [getPayInOutList.pending]: (state, action) => {
      state.payInOutListLoading = true;
    },
    [getPayInOutList.rejected]: (state, action) => {
      state.payInOutList = [];
      state.payInOutListLoading = false;
    },
    [getPayInOutList.fulfilled]: (state, action) => {
      if (action.payload.data.records.length > 0) {
          if(action.payload.type=="pay-in"){
            state.payInList = action.payload.page === 1 ? action.payload.data.records : [...state.payInList, ...action.payload.data.records];;
            state.totalPayInRecord = action.payload.data.totalRecords;  
          }else{
            state.payOutList = action.payload.page === 1 ? action.payload.data.records : [...state.payOutList, ...action.payload.data.records];;
            state.totalPayOutRecord = action.payload.data.totalRecords;  
          }
      } 
      state.payInOutListLoading = false;
    },
    //getSymbolExpiryFromSymbol
    [getSymbolExpiryFromSymbol.pending]: (state, action) => {
      state.expiryDatesBySymbolList = [];
    },
    [getSymbolExpiryFromSymbol.rejected]: (state, action) => {
      state.expiryDatesBySymbolList = [];
    },
    [getSymbolExpiryFromSymbol.fulfilled]: (state, action) => {
      state.expiryDatesBySymbolList = action.payload;
    },

    [getEditDataObjectCommon.pending]: (state, action) => { },
    [getEditDataObjectCommon.rejected]: (state, action) => {
      state.editDataObjectCommon = [];
    },
    [getEditDataObjectCommon.fulfilled]: (state, action) => {
      state.editDataObjectCommon = action.payload;
    },

    [getRightsForSession.rejected]: (state, action) => {
      state.rightsSessionList = [];
    },
    [getRightsForSession.fulfilled]: (state, action) => {
      state.rightsSessionList = action.payload;
    },
  },
});

export const {
  showMessage,
  hideMessage,
  setOpenDeleteConfirmDialog,
  setSymbolList,
  setAgentORSubBrokerList,
  setAccountOptionList,
  setIsNavbarHidden,
  setEditDataObjectCommon,
  setFocusState,
  setCommonAllUsers,
  setSymbolListWithExpiry,
  setIsAcceptedRules,
  setIsBankUpdated,
} = commonSlice.actions;

export default commonSlice.reducer;
